import React from 'react'
import customerStore from '../datastore/CustomerStore'

export function useContactPrompt({ emailOnly = false } = {}) {
  const [showModal, setShowModal] = React.useState(false)
  const pendingRef = React.useRef<(() => void) | null>(null)

  const needsContact = emailOnly
    ? !customerStore.email
    : !customerStore.email || !customerStore.phone

  // If contact info is missing, show the modal and queue the action to run after close.
  // If contact info is already present, run the action immediately.
  // Call without an action to just show the modal (e.g. after adding a doctor/pharmacy).
  const prompt = (action?: () => void) => {
    if (needsContact) {
      pendingRef.current = action ?? null
      setShowModal(true)
    } else {
      action?.()
    }
  }

  const handleClose = () => {
    setShowModal(false)
    const action = pendingRef.current
    pendingRef.current = null
    action?.()
  }

  return { showModal, handleClose, prompt }
}
